import { forwardRef } from 'react';
import { cx } from '@emotion/css';
import DefaultSelect from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import FieldGroup from '../field-group';

import useSelectMapOptions from './usecase/use-select-map-options';
import { SelectBaseProps } from './types';
import { selectCx } from './styles';

const SelectBase = forwardRef<HTMLDivElement, SelectBaseProps>((props, ref) => {
  const {
    name,
    helperText,
    label,
    value,
    className,
    selectClassName,
    options,
    children,
    isInvalid,
    error,
    ...resProps
  } = props;

  if (children && options) {
    throw new Error("You can't use children and options at the same time.");
  }

  const { mappedOptions } = useSelectMapOptions({ options });

  return (
    <FieldGroup
      invalid={isInvalid}
      error={error}
      helperText={helperText}
      className={className}
      ref={ref}
      name={name}
    >
      <FormControl>
        <InputLabel style={{ fontSize: 13 }}>{label}</InputLabel>
        <DefaultSelect
          {...resProps}
          label={label}
          name={name}
          className={cx(selectClassName, selectCx)}
          data-filled={Boolean(value)}
          variant='standard'
          error={isInvalid}
          value={value}
        >
          {children ?? mappedOptions}
        </DefaultSelect>
      </FormControl>
    </FieldGroup>
  );
});

export default SelectBase;
